export default {
  namespaced: true,
  state: {
    isLoaderVisible: false,
    alertModel: {
      showAlert: false,
      alertTitle: "",
      alertText: "",
      closeButtonText: "OK",
      buttonLink: "",
      buttonLinkText: "",
      onHide: null,
    },
    header: {
      title: "",
      tail: null,
    },
  },
  mutations: {
    SET_LOADER_STATUS: (state, data) => (state.isLoaderVisible = data),
    SET_ALERT_MODEL: (state, data) => (state.alertModel = data),
    SET_HEADER_TITLE: (state, title) => (state.header.title = title),
    SET_HEADER_TAIL: (state, tailOptions) =>
      (state.header.tail = { ...tailOptions }),
  },
  getters: {
    getLoaderStatus: (state) => {
      return state.isLoaderVisible;
    },
    getAlertModel: (state) => {
      return state.alertModel;
    },
    getHeaderTitle(state) {
      return state.header.title;
    },
    getHeaderTail(state) {
      return state.header.tail;
    },
  },
  actions: {
    setLoaderStatus({ commit }, status) {
      commit("SET_LOADER_STATUS", status);
    },
    setHeaderTail({ commit }, tailOptions) {
      commit("SET_HEADER_TAIL", tailOptions);
    },
    setHeaderTitle({ commit }, title) {
      commit("SET_HEADER_TITLE", title);
    },
    showAlert({ commit }, { title, text, btnCloseText, btnLink, btnLinkText, onHide }) {
      const newAlert = { showAlert: true };
      if (title) {
        newAlert.alertTitle = title;
      }
      if (text) {
        newAlert.alertText = text;
      }


      newAlert.closeButtonText = btnCloseText || "OK";

      if (btnLink) {
        newAlert.buttonLink = btnLink;
        newAlert.buttonLinkText = btnLinkText;
      }

      if (onHide) {
        newAlert.onHide = onHide;
      }

      commit("SET_ALERT_MODEL", newAlert);
    },
    hideAlert({ commit }) {
      const newAlert = { showAlert: false };
      commit("SET_ALERT_MODEL", newAlert);
    },
  },
};
